import React from "react";
import { ConditionScaleContent } from "@/components/ConditionRating";

export default function ConditionGuide() {
  return (
    <div className="container-lookers py-16 max-w-2xl" data-testid="condition-guide-page">
      <h1 className="font-serif text-5xl mb-3 text-zinc-900">
        Our Condition Scale
      </h1>
      <h2 className="font-heading text-sm uppercase tracking-wide mb-6 text-teal-700">Every Pair Is Different.</h2>
      <p className="text-sm text-zinc-500 mb-10">
        That's part of what makes preloved eyewear interesting. Every pair sold by Lookers is individually inspected and given a Condition Rating from 1 to 10 so you know exactly what you're buying. We look at the overall presentation of the frames as well as wear to the frame, arms, hinges, nose pads, logos and other visible components.
      </p>
      <ConditionScaleContent />
    </div>
  );
}
